"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _common = require("./common");
var _StatusOptionRenderer = require("./StatusOptionRenderer");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _StatusDropdownMenuUtils = require("./StatusDropdownMenuUtils");
var _featureFlags = require("../../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const nullableOptionRenderer = payload => {
  if (payload) {
    return (0, _StatusOptionRenderer.StatusOptionRenderer)(payload);
  }
};
const StatusDropdown = _ref => {
  let {
    status,
    statusOptions,
    onChange,
    defaultIsOpen,
    onClose,
    onClear,
    isClearable,
    disabled
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase1Batch1);
  const handleChange = (0, _react.useCallback)(option => {
    if (option) {
      onChange(option.value);
    } else if (isClearable) {
      onClear && onClear();
    }
  }, [onChange, onClear, isClearable]);
  const items = (0, _react.useMemo)(() => (0, _common.getStatusesAsDropdownOptions)(statusOptions), [statusOptions]);
  // must be referential equality
  const selectedOption = status ? items.find(item => item.value === status) : null;
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.SelectBoxWrapper, {
    value: selectedOption,
    options: items,
    onChange: handleChange,
    defaultIsOpen: defaultIsOpen,
    onClose: onClose,
    optionRenderer: nullableOptionRenderer,
    valueRenderer: nullableOptionRenderer,
    clearable: isClearable,
    placeholder: T.translate("filterPanel.statusPlaceholder"),
    menuStyle: {
      maxHeight: 340
    },
    disabled: disabled
  });
  const NewDropdown = () => {
    const {
      controlProps,
      menuProps
    } = (0, _alloyReactDropdown.useDropdown)({
      items,
      defaultSelectedItem: selectedOption,
      initialIsOpen: defaultIsOpen,
      selectedItem: selectedOption,
      onSelectedItemChange: changes => {
        var _changes$selectedItem;
        return handleChange((_changes$selectedItem = changes.selectedItem) !== null && _changes$selectedItem !== void 0 ? _changes$selectedItem : null);
      },
      id: "status-dropdown"
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.Control, _extends({}, controlProps, {
      disabled: disabled,
      onBlur: onClose,
      renderItem: _ref2 => {
        let {
          selectedItem
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement(_StatusDropdownMenuUtils.StatusDropdownControlItem, {
          status: selectedItem.label
        });
      },
      placeholder: T.translate("filterPanel.statusPlaceholder"),
      "data-testid": "status-dropdown-control"
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.SingleSelectMenu, _extends({}, menuProps, {
      style: {
        maxHeight: "unset"
      },
      renderMenuItem: _ref3 => {
        let {
          item,
          ...props
        } = _ref3;
        return /*#__PURE__*/_react.default.createElement(_StatusDropdownMenuUtils.StatusDropdownMenuItem, {
          status: item.value,
          props: props
        });
      },
      "data-testid": "status-dropdown-menu"
    })));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.StatusDropdown = StatusDropdown;
//# sourceMappingURL=StatusDropdown.js.map